import React from 'react';
import styled from 'styled-components';
import { useStoreActions, useStoreState } from 'easy-peasy';
import Checkbox from '@material-ui/core/Checkbox';

const zoomId = 'zoomer';

const Wrapper = styled.div`
  line-height: 1;

  label {
    display: flex;
    cursor: pointer;
    align-items: center;
    user-select: none;
  }

  .MuiButtonBase-root {
    margin-left: -9px;
  }

  .MuiCheckbox-colorPrimary {
    color: ${(p) => p.theme.colors.interaction};
  }
`;

const ViewSwitcher = () => {
  const setZoomView = useStoreActions((actions) => actions.app.setZoomView);
  const isZoomView = useStoreState((state) => state.app.isZoomView);

  return (
    <Wrapper>
      <label htmlFor={zoomId}>
        <Checkbox
          checked={isZoomView}
          id={zoomId}
          onChange={(evt) => setZoomView(evt.target.checked)}
          disableRipple
        />
        Ausschnitt vergrößern
      </label>
    </Wrapper>
  );
};

export default ViewSwitcher;
